// import ScrollMagic from 'scrollmagic';
// require('scrollmagic/scrollmagic/minified/plugins/animation.gsap.min');

let scrollAnimations = {
    init() {


        var controller = new ScrollMagic.Controller();


        $('.scrollopacity').each(function(){
            var currentStrong = this;

            var scene = new ScrollMagic.Scene({
            triggerElement: currentStrong,
                duration: 100,
                offset: -400,
            }).on("enter", function (e) {
                var tl = new TimelineMax();
                    tl.to(currentStrong, 0.3, {css: {opacity: 1, top: 0}}, 0.2);

            });

            controller.addScene([
                scene
            ]);
        })
    },

    picto(){
        var controller = new ScrollMagic.Controller();

        var sceneHeight = $('.app').height() ;
        //var sceneHeight = sceneHeight / 3 ;
        //console.log(sceneHeight);

        var scene1 = new ScrollMagic.Scene({
            triggerElement: '.app',
            //triggerHook: 1,
            duration: sceneHeight
        })
        .setTween(".picto-page", 1, {
            bottom: '100%'
        })
        //.addIndicators() // add indicators (requires plugin)
        .addTo(controller);


        // var position = $(window).scrollTop();
        // // should start at 0

        // $(window).scroll(function() {
        //     var scroll = $(window).scrollTop();
        //     if(scroll > position) {
        //         //console.log('scrollDown');
        //         $('.bubulle').addClass('speed');

        //     }else {
        //         //console.log('scrollUp');
        //         $('.bubulle').removeClass('speed');
        //     }

        //     position = scroll;
        // });



    }
}

export default scrollAnimations;
